<template>
  <BaseDialog :isOpen="isOpen" @updateDialog="cancel">
    <template v-slot:title>
      <span v-if="!workersMissingComplianceChecks.length">
        Are you sure you want to confirm the allocation of this worker?
      </span>
      <span v-else>
        You are unable to confirm these allocations
      </span>
    </template>
    <template v-slot:body>
      <div
        v-if="!workersMissingComplianceChecks.length"
        class="confirm-allocations-description"
      >
        Confirmed allocations will have timesheets generated.
      </div>
      <div v-else class="confirm-allocations-description">
        <p>
          One or more of the workers in the selected shifts does not meet the
          compliance requirements, please update their profiles before
          continuing
        </p>
        <div
          v-for="(worker, index) in workersMissingComplianceChecks"
          :key="index"
          class="mb-8 d-flex"
        >
          <div class="icon-wrapper mr-1">
            <v-icon>mdi-account</v-icon>
          </div>
          <div>
            <h3>{{ worker.worker }}</h3>
            <div class="mt-1">Doesn't meet the following requirements:</div>
            <div
              v-for="(complianceCheck, index) in worker.missingComplianceChecks"
              :key="index"
            >
              {{ index + 1 }}. {{ complianceCheck }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:actions>
      <div class="confirm-allocations-actions">
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <PrimaryButton
          v-if="!workersMissingComplianceChecks.length"
          :loading="isLoading"
          @click.native="handleConfirmAllocation"
        >
          Confirm Allocation
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { APPLICATION_NAMESPACE } from "@/store/modules/applications";
import {
  CONFIRM_ALLOCATION,
  UPDATE_APPLICATION_SHIFTS_STATUS
} from "@/store/modules/applications/actions";
import { SHIFT_STATUSES } from "@/constants/shifts";
import { BOOKINGS_NAMESPACE } from "@/store/modules/bookings/actions";

const { mapActions } = createNamespacedHelpers(APPLICATION_NAMESPACE);
const { mapState } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "ConfirmCandidateAllocationDialog",
  components: { BaseDialog, PrimaryButton },
  props: {
    isOpen: Boolean,
    applicationIds: Array,
    workersMissingComplianceChecks: {
      type: Array,
      default: () => []
    }
  },
  inject: ["currentBookingId"],
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapState({
      currentBooking: state => state.currentBooking
    })
  },
  methods: {
    ...mapActions({
      confirmAllocation: CONFIRM_ALLOCATION,
      updateApplicationShiftsStatus: UPDATE_APPLICATION_SHIFTS_STATUS
    }),
    async handleConfirmAllocation() {
      this.isLoading = true;
      try {
        await this.updateApplicationShiftsStatus({
          applicationShifts: this.applicationIds,
          status: SHIFT_STATUSES.CONFIRMED,
          all: true,
          booking: this.currentBooking
        });
        this.$emit("confirmed");
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$emit("close", { updateList: false });
    }
  }
};
</script>

<style lang="scss">
.confirm-allocations-description {
  min-height: 100px;
}
.confirm-allocations-actions {
  padding: 0.5rem;
}
</style>
